type SparkLineProps = {
  data: number[];
  width?: number;
  height?: number;
  color?: string;
  fill?: boolean;
};

export function SparkLine({
  data,
  width = 90,
  height = 30,
  color = '#D4B15C',
  fill = true,
}: SparkLineProps) {
  if (!data || data.length < 2) return null;
  const max = Math.max(...data, 1);
  const min = Math.min(...data, 0);
  const range = max - min || 1;
  const step = width / (data.length - 1);
  const points = data.map(
    (v, i) => [i * step, height - ((v - min) / range) * (height - 4) - 2] as const,
  );
  const path = points
    .map((p, i) => `${i ? 'L' : 'M'}${p[0].toFixed(1)} ${p[1].toFixed(1)}`)
    .join(' ');
  const areaPath = `${path} L ${width} ${height} L 0 ${height} Z`;
  return (
    <svg width={width} height={height} viewBox={`0 0 ${width} ${height}`}>
      <title>Log volume trend</title>
      {fill && <path d={areaPath} fill={color} fillOpacity="0.10" />}
      <path d={path} stroke={color} strokeWidth="1.4" fill="none" />
    </svg>
  );
}
